import React from 'react';

interface TaglineLivePreviewProps {
    tagline: string;
    span: string;
    url: string;
    bgColor: string;
    taglineColor: string;
    spanColor: string;
    taglineFontSize: number;
    spanFontSize: number;
    highlightedElement: string | null;
}

const TaglineLivePreview: React.FC<TaglineLivePreviewProps> = ({
    tagline,
    span,
    url,
    bgColor,
    taglineColor,
    spanColor,
    taglineFontSize,
    spanFontSize,
    highlightedElement
}) => {
    return (
        <div className="tagline-preview-container">
            <h3>Live Preview</h3>

            <div
                className={`preview-bar ${highlightedElement === 'background' ? 'highlight-preview-bg' : ''}`}
                style={{ backgroundColor: bgColor }}
            >
                {span && (
                    <span
                        className={highlightedElement === 'text1' ? 'highlight-preview-text' : ''}
                        style={{ color: spanColor, fontSize: `${spanFontSize}px` }}
                    >
                        {span}
                    </span>
                )}

                {url.trim() ? (
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`preview-link ${highlightedElement === 'text2' ? 'highlight-preview-text' : ''}`}
                        style={{ color: taglineColor, fontSize: `${taglineFontSize}px` }}
                        onClick={(e) => e.preventDefault()}
                    >
                        {tagline || ' Text 2 Preview'}
                    </a>
                ) : (
                    <span
                        className={highlightedElement === 'text2' ? 'highlight-preview-text' : ''}
                        style={{ color: taglineColor, fontSize: `${taglineFontSize}px` }}
                    >
                        {tagline || ' Text 2 Preview'}
                    </span>
                )}
            </div>
        </div>
    );
};

export default TaglineLivePreview;